<template>
  <div>
    <template v-if="!loading">
      <protocol-header v-if="protocol"
                       :protocol="protocol"></protocol-header>
      
      <amendment-header v-if="amendment"
                        :amendment="amendment"></amendment-header>
      
      <div class="row">
        <div class="col-12">
          <div class="card card-fluid mt-4 mx-auto">
            <input ref="reply" name="reply" type="hidden">
            
            <div class="card-header">
              <h1 class="card-title mb-0">Participación como revisor en enmienda</h1>
            </div>
            
            <div class="card-body">
              <a href="#"
                 class="btn btn-outline-primary btn-block btn-lg block mb-4"
                 @click.prevent="showAmendment = !showAmendment">{{
                  showAmendment
                    ? 'Ocultar detalles de la enmienda'
                    : 'Ver detalles de la enmienda (Anexos)'
                                                                 }}</a>
              
              <div v-if="showAmendment">
                <component :is="currentAmendment"
                           :committee="committee"
                           :protocol="protocol"
                           :amendment="amendment"
                           :task="task"
                           :readonly="true"
                           :readonlyFiles="true"
                           :hide-headers="true"></component>
              </div>
              
              <div v-else>
                <div v-if="!invitationAccepted">
                  <p>Usted ha sido invitado a participar como revisor en la enmienda del
                     protocolo
                    <strong>{{ protocol.title }}</strong> el cual será dirigido por<strong>
                      {{ protocol.user.full_name }}</strong>
                  </p>
                </div>
                <div v-if="invitationAccepted">
                  <div v-if="loadingDictums"
                       class="text-center">
                    <div class="spinner-border text-success" role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <div v-else>
                    <form method="post"
                          @submit.prevent=""
                          ref="form">
                      <div class="form-group">
                        <label class="d-block font-weight-normal"
                               for="dictum">Tipo de dictamen:
                          <abbr style="text-decoration: none;"
                                title="Campo obligatorio">*</abbr>
                        </label>
                        <select name="dictum"
                                id="dictum"
                                class="custom-select"
                                v-model="selectedDictum">
                          <option value="" disabled>
                            Seleccione el tipo de dictamen
                          </option>
                          <option v-for="dictum in dictums"
                                  :key="dictum.id"
                                  :value="dictum.id">
                            {{ dictum.title }}
                          </option>
                        </select>
                      </div>
                      
                      <div class="form-group">
                        <label class="d-block font-weight-normal"
                               for="comments">Comentarios:
                          <abbr style="text-decoration: none;"
                                title="Campo obligatorio">*</abbr>
                        </label>
                        <textarea cols="5"
                                  rows="5"
                                  name="comments"
                                  id="comments"
                                  v-model="comments"
                                  class="form-control"
                                  placeholder="Escriba sus comentarios"></textarea>
                      </div>
                      
                      <div class="form-group" v-if="committee.key === 'investigacion'">
                        <label class="d-block font-weight-normal"
                               for="send_dictum">¿Puede enviarse el dictamen y comentarios al responsable del
                                                 proyecto?:
                          <abbr style="text-decoration: none;"
                                title="Campo obligatorio">*</abbr>
                        </label>
                        <select name="send_dictum"
                                id="send_dictum"
                                class="custom-select"
                                v-model="sendDictum">
                          <option value=""
                                  disabled>Seleccione una opción
                          </option>
                          <option value="1">Sí</option>
                          <option value="0">No</option>
                        </select>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="card-footer d-flex py-2 px-2" v-if="!showAmendment">
              <button class="btn btn-lg btn-primary mr-2"
                      data-toggle="modal"
                      data-target="#accept-modal"
                      type="button"
                      v-if="!invitationAccepted">
                Aceptar participación
              </button>
              <button class="btn btn-lg btn-primary mr-2"
                      type="button"
                      @click="saveDictum"
                      :disabled="saving"
                      v-else>
                <span class="spinner-border text-white spinner-border-sm" role="status" v-if="saving">
                  <span class="sr-only">Loading...</span>
                </span>
                Guardar dictamen
              </button>
              
              <button class="btn btn-lg btn-danger"
                      data-toggle="modal"
                      data-target="#reject-modal"
                      type="button"
                      v-if="!invitationAccepted">
                Rechazar participación
              </button>
            </div>
          </div>
        </div>
      </div>
    </template>
    
    <div v-else
         class="text-center">
      <div class="spinner-border text-success" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    
    <portal to="modals">
      <ok-cancel-dialog id="accept-modal"
                        title="Aceptar participación"
                        content="<p>Por favor confirme su participación como revisor en el protocolo</p>"
                        :ok-button-text="'Confirmar participación'"
                        @ok-button-pressed="acceptInvitation"
                        ref="accept-modal"></ok-cancel-dialog>
      
      <reject-reviewer-invitation id="reject-modal"
                                  title="Rechazar participación"
                                  ok-button-text="Rechazar participación"
                                  :protocol="protocol"
                                  :amendment="amendment"
                                  :user="user"
                                  :committee="committee"
                                  @close-task="$emit('close-task')"></reject-reviewer-invitation>
    </portal>
  </div>
</template>

<script>
  import ProtocolHeader from './ProtocolHeader'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import RejectReviewerInvitation from './commons/RejectReviewerInvitation'
  import { mapActions, mapGetters } from 'vuex'
  import { find } from 'lodash'
  import { AlertManager } from '../utils/AlertManager'
  import 'jquery-validation'
  import autosize from 'autosize'
  import AmendmentHeader from '../amendments/AmendmentHeader'
  import AmendmentTitle from '../amendments/AmendmentTitle'
  import AmendmentProtocol from '../amendments/AmendmentProtocol'
  import AmendmentCancellation from '../amendments/AmendmentCancellation'
  import AmendmentResearchers from '../amendments/AmendmentResearchers'
  import AmendmentResponsible from '../amendments/AmendmentResponsible'
  import AmendmentExtension from '../amendments/AmendmentExtension'
  
  export default {
    name: 'ReviewerAmendmentInvite',
    components: {
      AmendmentHeader,
      ProtocolHeader,
      OkCancelDialog,
      RejectReviewerInvitation,
      AmendmentTitle,
      AmendmentResponsible,
      AmendmentExtension,
      AmendmentResearchers,
      AmendmentCancellation,
      AmendmentProtocol,
    },
    props: {
      user: Object,
      protocol: Object,
      amendment: Object,
      task: Object,
    },
    data () {
      return {
        loading: true,
        loadingDictums: false,
        saving: false,
        invitation: null,
        dictums: [],
        selectedDictum: '',
        comments: null,
        sendDictum: '',
        showAmendment: false,
        currentAmendment: null,
      }
    },
    methods: {
      ...mapActions({
        getCommittees: 'committees/getCommittees',
        getReviewerInvitation: 'amendments/getReviewerInvitation',
        getReviewerDictums: 'amendments/getReviewerDictums',
        replyInvitation: 'amendments/replyInvite',
        saveReviewerDictum: 'amendments/saveReviewerDictum',
      }),
      
      async acceptInvitation () {
        this.$refs['accept-modal'].sending = true
        
        try {
          const response = await this.replyInvitation({
            amendment: this.amendment,
            user: this.user,
            committee: this.committee,
            reply: 'accept',
          })
          
          if (response.status === 'error') {
            AlertManager.error(response.error)
            
            this.$refs['accept-modal'].sending = false
            this.$refs['accept-modal'].close()
            
            return
          }
          
          AlertManager.success(response.message)
        } catch (e) {
          this.loading = false
          
          this.$refs['accept-modal'].sending = false
          this.$refs['accept-modal'].close()
        }
        
        // Reload invitation
        this.loading = true
        
        this.invitation = (await this.getReviewerInvitation({
          amendment: this.amendment,
          user: this.user,
          committee: this.committee,
        })).invitation
        
        this.loading = false
        
        this.$refs['accept-modal'].close()
        
        // Load reviewers dictums.
        await this.loadDictums()
      },
      async loadDictums () {
        this.loadingDictums = true
        
        this.dictums = await this.getReviewerDictums({
          amendment: this.amendment,
          user: this.user,
          committee: this.committee,
        })
        
        this.loadingDictums = false
      },
      async saveDictum () {
        if ($(this.$refs.form).valid()) {
          this.saving = true
          
          const response = await this.saveReviewerDictum({
            model: this.amendment,
            user: this.user,
            committee: this.committee,
            comments: this.comments,
            dictum: this.selectedDictum,
            send_dictum: this.sendDictum,
          })
          
          this.saving = false
          
          if (response && response.data) {
            const {
                    error,
                    message,
                    status,
                  } = response.data.data
            
            if (status === 'error') {
              AlertManager.error(error)
              
              return false
            }
            
            AlertManager.success(message)
            
            this.$emit('close-task')
          }
        }
      },
      showRejectDialog () {
        $('#reject-modal').modal('show')
      },
    },
    computed: {
      ...mapGetters({
        committees: 'committees/committees',
      }),
      
      committee () {
        const classificationCommittees = {
          'participa_enmienda_por_etica': 'etica',
          'participa_enmienda_por_bioseguridad': 'bioseguridad',
          'participa_enmienda_por_investigacion': 'investigacion',
          'dictamen_revisor_enmienda_por_etica': 'etica',
          'dictamen_revisor_enmienda_por_bioseguridad': 'bioseguridad',
          'dictamen_revisor_enmienda_por_investigacion': 'investigacion',
        }
        
        return find(this.committees,
          committee => committee.key === classificationCommittees[this.task.classification.key])
      },
      invitationAccepted () {
        return !(!this.invitation || this.invitation.status.key !== 'aceptado')
      },
    },
    async mounted () {
      this.loading = true
      
      await this.getCommittees({})
      
      autosize($('textarea'))
      
      this.invitation = (await this.getReviewerInvitation({
        amendment: this.amendment,
        user: this.user,
        committee: this.committee,
      })).invitation
      
      this.loading = false
      
      if (this.invitationAccepted) {
        await this.loadDictums()
      }

      autosize(document.getElementById('comments'))
          
      $(this.$refs.form).validate({
        highlight: function (element, errorClass, validClass) {
          $(element).addClass('is-invalid')
        },
        unhighlight: function (element, errorClass, validClass) {
          $(element).removeClass('is-invalid')
        },
        errorPlacement: function (label, element) {
          label.addClass('invalid-feedback')
          
          if (element.is(':radio')) {
            label.insertAfter($('[data-name=\'' + element.attr('name') + '\']'))
          }
          else {
            label.insertAfter(element)
          }
        },
        rules: {
          dictum: 'required',
          comments: 'required',
          send_dictum: this.committee.key === 'investigacion' ? 'required' : '',
        },
        messages: {
          dictum: {
            required: 'Seleccione un dictamen',
          },
          comments: {
            required: 'Proporcione sus comentarios',
          },
          send_dictum: {
            required: 'Seleccione una opción',
          },
        },
      })
      
      if (window.onMounted) {
        this[window.onMounted]()
      }
      
      // Set current amendment.
      // TODO: Complete this.
      const amendmentTypes = {
        'cancelacion_proyecto': 'AmendmentCancellation',
        'prorroga': 'AmendmentExtension',
        'coinvestigadores': 'AmendmentResearcher',
        'protocolo': 'AmendmentProtocol',
        'cambio_titulo': 'AmendmentTitle',
        'investigador_responsable': 'AmendmentResponsibleResearcher',
      }
      
      this.currentAmendment = amendmentTypes[this.amendment.type.key]
    },
  }
</script>
